import axios from 'axios'
import { api } from '../api'
import { createSelector } from 'reselect'
import mockprojects from '../mocks/projects'
import mocktypes from '../mocks/types'
import mockobjects from '../mocks/objects'

/**
 * Constants
 * */
export const moduleName = 'realty'


export const START = '_START'
export const SUCCESS = '_SUCCESS'
export const ERROR = '_ERROR'

export const REALTY_PROJECTS = `${moduleName}/REALTY_PROJECTS`
export const REALTY_TYPES = `${moduleName}/REALTY_TYPES`
export const REALTY_OBJECTS = `${moduleName}/REALTY_OBJECTS`

const projects = localStorage.getItem('projects') && localStorage.getItem('projects') !== 'undefined' ? JSON.parse(localStorage.getItem('projects')) : null
const types = localStorage.getItem('types') && localStorage.getItem('types') !== 'undefined' ? JSON.parse(localStorage.getItem('types')) : null


/**
 * Reducer
 * */
const defaultState = {
	loading: false,
	loaded: false,
    error: null,
    projects: projects,
    types: types,
	objects: null
}

export default (state = defaultState, action) => {
    const { type, error, response } = action

    switch (type) {
        case REALTY_PROJECTS + START:
            return { 
                ...state, 
                loading: true 
        }
        case REALTY_PROJECTS + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                projects: response
        }
        case REALTY_PROJECTS + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
        }
        case REALTY_TYPES + START:
            return { 
                ...state, 
                loading: true 
        }
        case REALTY_TYPES + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                types: response
        }
        case REALTY_TYPES + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
        }
        case REALTY_OBJECTS + START:
            return { 
                ...state, 
                loading: true 
        }
        case REALTY_OBJECTS + SUCCESS:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                objects: response
        }
        case REALTY_OBJECTS + ERROR:
            return { 
                ...state, 
                loading: false, 
                loaded: true,
                error
        }
        default:
            return state
    }
}

/**
 * Action Creators
 * */

export const setRealtyProjects = (data) => async (dispatch) => {
	//console.log(data)
	if (data.success) {
		dispatch({
			type: REALTY_PROJECTS + SUCCESS,
			response: data.content.ProjectsInfo
		});
		localStorage.setItem("projects", JSON.stringify(data.content.ProjectsInfo));
	}
}

export const setRealtyTypes = (data) => async (dispatch) => {
	//console.log(data)
	if (data.success) {
		dispatch({
			type: REALTY_TYPES + SUCCESS,
			response: data.content.TypesInfo
		});
		localStorage.setItem("types", JSON.stringify(data.content.TypesInfo));
	}
}

export const realtyGetProjects = (params) => async (dispatch) => {

    //localStorage.setItem("projects", JSON.stringify(mockprojects.content.ProjectsInfo));
    //return dispatch({ type: REALTY_PROJECTS + SUCCESS, response: mockprojects.content.ProjectsInfo })

	dispatch({ type: REALTY_PROJECTS + START })
	
	try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString())
		console.log(data);

		if (data.success) {
			dispatch({
				type: REALTY_PROJECTS + SUCCESS,
				response: data.content.ProjectsInfo
			});
			localStorage.setItem("projects", JSON.stringify(data.content.ProjectsInfo));
		} else if(data.error) {
			dispatch({
				type: REALTY_PROJECTS + ERROR,
				error: data.message
			});			
			localStorage.removeItem("projects");
		}
	} catch (error) {
		console.log(error)
		if (error.response)
			dispatch({
				type: REALTY_PROJECTS + ERROR,
				error: error.response
			});
			localStorage.removeItem("projects");
	}	
}


export const realtyGetTypes = (params) => async (dispatch) => {

    //localStorage.setItem("types", JSON.stringify(mocktypes.content.TypesInfo));
    //return dispatch({ type: REALTY_TYPES + SUCCESS, response: mocktypes.content.TypesInfo })

	dispatch({ type: REALTY_TYPES + START })
	
	try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString())
		//console.log(data);

		if (data.success) {
			dispatch({
				type: REALTY_TYPES + SUCCESS,
				response: data.content.TypesInfo
			});
			localStorage.setItem("types", JSON.stringify(data.content.TypesInfo));
			
		} else if(data.error) {
			dispatch({
				type: REALTY_TYPES + ERROR,
				error: data.message
			});		
			localStorage.removeItem("types");	
		}
	} catch (error) {
		console.log(error)
		if (error.response)
			dispatch({
				type: REALTY_TYPES + ERROR,
				error: error.response
			});
			localStorage.removeItem("types");
	}	
}

export const realtyGetObjects = (params) => async (dispatch) => {

    return dispatch({ type: REALTY_OBJECTS + SUCCESS, response: mockobjects.content.PremisessInfo })

	dispatch({ type: REALTY_OBJECTS + START })
	
	try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString())
		console.log(data);

		if (data.success) {
			dispatch({
				type: REALTY_OBJECTS + SUCCESS,
				response: data.content.PremisessInfo
			});
			
		} else if(data.error) {
			dispatch({
				type: REALTY_OBJECTS + ERROR,
				error: data.message
			});		
		}
	} catch (error) {
		console.log(error)
		if (error.response)
			dispatch({
				type: REALTY_TYPES + ERROR,
				error: error.response
			});
	}	
}

/**
 * Selectors
 * */

export const selectProjects = (state) => state.realty.projects;
export const selectTypes = (state) => state.realty.types;
export const selectObjects = (state) => state.realty.objects;

export const selectObjectsList = createSelector(
    [
        selectObjects,
        selectProjects,
        selectTypes,
    ],
    (objects, projects, types) => {
        
        if(objects && projects && types) {
            
            let expandedArray = objects.map(object => {
                let project = projects.filter(obj => obj.id === object.projectId)
                let type = types.filter(obj => obj.id === object.typeId)
                
                return (
                    { 
                        ...object, 
                        project: project.length ? project[0].name : '',  
                        type: type.length ? type[0].name : '', 
						location: 'Локация 1'
                    }
                )
            });

           //console.log(expandedArray)
           return expandedArray
        }
    }
)